module.exports = __webpack_public_path__ + "static/media/Brighton bat.a8825273.jpg";